import { AnanseApiService } from "./AnanseApiService";

type UserAddress = {
  zipcode?: string;
  street?: string;
  city?: string;
  state?: string;
  country?: string;
};

type UserDetails = {
  id: number;
  email: string;
  mobilePhone?: string;
  nome: string;
  cpf?: string | null;
  document?: string | null;
  ativo?: boolean;
  deletedAt?: string | null;
  profile: { nome: string } | string;
  birthday?: string | null;
  genre?: string | null;
  address?: UserAddress | null;
  settingsPassword?: string;
  grouper?: boolean;
  grouperId?: number;
  usersLicense?: number;
  devicesLicense?: number;
  consumptionControl?: string;
  userType?: string;
};

export class UserPaymentDateService {
  private readonly api = new AnanseApiService();

  async update(userId: number, nextPaymentDate: string | null): Promise<void> {
    const user = (await this.api.makeHttpRequest({
      method: "GET",
      url: `/usuario/${userId}`,
    })) as UserDetails;

    const address = user.address
      ? {
          zipcode: user.address.zipcode,
          street: user.address.street,
          city: user.address.city,
          state: user.address.state,
          country: user.address.country,
        }
      : null;

    await this.api.makeHttpRequest({
      method: "PUT",
      url: `/usuario/${userId}`,
      data: {
        email: user.email,
        mobilePhone: user.mobilePhone,
        nome: user.nome,
        cpf: user.cpf ?? null,
        document: user.document ?? null,
        ativo: typeof user.ativo === "boolean" ? user.ativo : !user.deletedAt,
        profile:
          typeof user.profile === "string" ? user.profile : user.profile.nome,
        birthday: user.birthday ?? "",
        genre: user.genre ?? "",
        address,
        nextPaymentDate,
        settingsPassword: user.settingsPassword,
        grouper: user.grouper ?? false,
        grouperId: user.grouperId ?? 0,
        usersLicense: user.usersLicense ?? 0,
        devicesLicense: user.devicesLicense ?? 0,
        consumptionControl: user.consumptionControl,
        userType: user.userType,
      },
    });
  }
}
